import { BCMSStateManagerCRUD, useModel } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageUI } from "components/pages/LoginPage";

/**
 * @name CaptureFastBalancesSetupView
 * @returns {React.Component}
 * @description Capture which shows the "Fast Balances" set up instructors. 
 * These are instructions that are not shown in the click thru currently.
 */
export default function CaptureFastBalancesSetupView(props) {
    const { branding } = useModel();
    const options = branding.options;

    // initalize a new BCMSStateManagerCRUD instance using the default page ui
    // updating the modal property
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "showFastBalancesSetupView" ], true)
        .submit();

    // Return the login page passing the data and ui variables
    return <LoginPage ui={ ui } />
}